import { CfCardPromoProps } from "components/Cards/CardPromo/CfCardPromo/schema";
import CardPromo, {
  CardPromoCta,
  Props as CardPromoProps,
} from "components/Cards/CardPromo";
import CfAnchor from "components/Anchor";
import Markdown from "react-markdown";
import React, { ReactNode } from "react";

const convertCfCardPromoProps = ({
  badgeLabel,
  ctaAnchor,
  ctaLabel,
  disclaimer,
  description,
  title,
}: CfCardPromoProps) => {
  const anchorProps: CardPromoCta =
    ctaAnchor && ctaLabel
      ? {
          variant: "link",
          ctaLabel,
          ctaAnchor: (children: ReactNode) => (
            <CfAnchor {...ctaAnchor}>{children}</CfAnchor>
          ),
        }
      : { variant: "no-cta" };

  const props: CardPromoProps = {
    title,
    description: description?.description ? (
      <Markdown>{description.description}</Markdown>
    ) : undefined,
    badgeLabel: badgeLabel || undefined,
    disclaimer: disclaimer?.disclaimer ? (
      <Markdown>{disclaimer.disclaimer}</Markdown>
    ) : undefined,
    ...anchorProps,
  };

  return props;
};

const CfCardPromo = (props: CfCardPromoProps) => (
  <CardPromo {...convertCfCardPromoProps(props)} />
);

export default CfCardPromo;
